import {
  POLYGON_FILL_COLOUR,
  LAYER_ID_POINTS,
  CIRCLE_OPACITY,
  LAYER_ID_POLYGONS,
  LAYER_ID_POLYGON_OUTLINE,
  LAYER_ID_POLYGON_DIAMONDS,
  MAP_ZOOM_DEFAULT,
  POLYGON_TOLERANCE,
  SOURCE_ID_POINTS,
  SOURCE_ID_POLYGONS,
  SOURCE_ID_POLYGON_CENTROIDS,
  POLYGON_OUTLINE_COLOR,
  MAP_IMAGE_POLYGON_DIAMOND,
  MAP_POLYGON_DETAIL_ZOOM,
  MAP_POLYGON_DIAMOND_FADE_END,
  POINT_CIRCLE_COLOUR,
  POINT_CIRCLE_RADIUS,
  POINT_STROKE_WIDTH
} from '@root/constants'

export function buildGeoDataMapLayerConfig(geoJsonData) {
  return {
    sources: {
      points: {
        id: SOURCE_ID_POINTS,
        source: {
          type: 'geojson',
          data: geoJsonData.points
        }
      },
      polygons: {
        id: SOURCE_ID_POLYGONS,
        source: {
          type: 'geojson',
          data: geoJsonData.polygons,
          tolerance: POLYGON_TOLERANCE
        }
      },
      polygonCentroids: {
        id: SOURCE_ID_POLYGON_CENTROIDS,
        source: {
          type: 'geojson',
          data: geoJsonData.polygon_centroids
        }
      }
    },
    layers: {
      polygons: {
        id: LAYER_ID_POLYGONS,
        layer: {
          type: 'fill',
          source: SOURCE_ID_POLYGONS,
          paint: {
            'fill-color': POLYGON_FILL_COLOUR,
            'fill-opacity': [
              'interpolate',
              ['linear'],
              ['zoom'],
              MAP_ZOOM_DEFAULT, 0.75,
              MAP_POLYGON_DETAIL_ZOOM, 0.55,
              MAP_POLYGON_DIAMOND_FADE_END, 0.45
            ]
          }
        },
        order: 0
      },
      polygonOutline: {
        id: LAYER_ID_POLYGON_OUTLINE,
        layer: {
          type: 'line',
          source: SOURCE_ID_POLYGONS,
          paint: {
            'line-color': POLYGON_OUTLINE_COLOR,
            'line-width': [
              'interpolate',
              ['linear'],
              ['zoom'],
              MAP_ZOOM_DEFAULT, 0.5,
              MAP_POLYGON_DETAIL_ZOOM, 1,
              MAP_POLYGON_DIAMOND_FADE_END, 2.5
            ],
            'line-opacity': [
              'interpolate',
              ['linear'],
              ['zoom'],
              MAP_ZOOM_DEFAULT, 0.35,
              MAP_POLYGON_DETAIL_ZOOM, 0.7,
              MAP_POLYGON_DIAMOND_FADE_END, 1
            ]
          }
        },
        order: 0
      },
      polygonDiamonds: {
        id: LAYER_ID_POLYGON_DIAMONDS,
        layer: {
          type: 'symbol',
          source: SOURCE_ID_POLYGON_CENTROIDS,
          layout: {
            'icon-image': MAP_IMAGE_POLYGON_DIAMOND,
            'icon-size': 1,
            'icon-allow-overlap': true,
            'icon-ignore-placement': true
          },
          paint: {
            'icon-opacity': [
              'interpolate',
              ['linear'],
              ['zoom'],
              MAP_POLYGON_DETAIL_ZOOM - 1, CIRCLE_OPACITY,
              MAP_POLYGON_DIAMOND_FADE_END, 0
            ]
          }
        },
        order: 0
      },
      points: {
        id: LAYER_ID_POINTS,
        layer: {
          type: 'circle',
          source: SOURCE_ID_POINTS,
          layout: {},
          paint: {
            'circle-color': POINT_CIRCLE_COLOUR,
            'circle-stroke-color': POINT_CIRCLE_COLOUR,
            'circle-radius': POINT_CIRCLE_RADIUS,
            'circle-stroke-width': POINT_STROKE_WIDTH,
            'circle-opacity': CIRCLE_OPACITY
          }
        },
        order: 0
      }
    }
  }
}
